import axios from 'axios';

export function loginApiCall(email: string, password: any) {
  // return axios.post(`/identity/TokenGenerate/IbosLogin`, {
  //   username: email,
  //   password: password,
  // });
  return axios.post(`/api/Auth/Login`, {
    loginId: email,
    password: password,
  });
}

// One-time login: the endpoint takes query-string params, not a JSON body.
export function verifyLoginOtpApiCall(email: string, otp: string) {
  return axios.post(`/api/Auth/VerifyLoginOtp`, null, {
    params: { email, otp },
  });
}

export function RegisterApiCall(
  email: string, 
  createPassword: any, 
  fullname:string, 
  company:string, 
  value:any, 
  isActive:boolean, 
  isEmailVerified:boolean) {

  return axios.post(`/api/Auth/signup`, {
    strLoginId: email,
    strPasswordHash: createPassword,
    strName: fullname,
    strCompanyName: company,
    strUserType: value,
    isActive,
    isEmailVerified,
  });
}


// export function allMenuList(userId: number) {
//   return axios.get(
//     `/rmg/Menu/GetMenuListPermissionWise?UserId=${userId}&isWeb=true`
//   );
// }
// export function businessUnitDDL(accId: number, userId: number) {
//   return axios.get(
//     `/rmg/Master/GetBusinessUnitDDL?AccountId=${accId}&UserId=${userId}`
//   );
// }
